import {
  UPDATE_POPUP,
} from '../actions/types';

const initialState = {
  popupId: null,
  closeable: true
};

const popupState = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_POPUP:
      state = {
        ...state,
        ...payload,
      };
      break;
    default:
      return state;
  }

  return {...state};
};

export default popupState;



// WEBPACK FOOTER //
// ./src/reducers/popup.js